import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Message, Panel } from 'rsuite'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
import { startLoading, doneLoading } from '../../utils/loading'
import ProgressIndicatorView from './ProgressIndicatorView'
import ProgressIndicatorForm from './ProgressIndicatorForm'
import {
  getProgressIndicator,
  updateProgressIndicator,
  saveProgressFeedback,
  updateProgressFeedback,
  deleteProgressFeedback,
  getProgressLinkageIndicators,
  saveProgressLinkageIndicators,
} from '../../redux/actions/projectProgress'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { getSchemaSidebar } from '../../redux/actions/sidebar'
import CommentForm from './CommentForm'
import CommentView from './CommentView'
import ButtonPanel from '../ButtonPanel'
import WarningMessage from '../../components/message/WarningMessage/WarningMessage'
import { cloneDeep } from 'lodash-es'
import notification from '../../utils/notification'
import { SAVE_SUCCESS_MSG } from '../../constants/msgText'
import ResultConnectionModal from '../projectProposal/objectiveGoal/ResultConnectionModal'
import pathname from '../../constants/pathname'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { Link } from 'react-router-dom'

export default function ProgressIndicatorWidget({
  schema: _schema,
  showConnectionButton,
  isWithdrawRequest,
  ...props
}) {
  const history = useHistory()
  const { showCommandButton, isEdit, onChangeIsEdit } = props
  const [isError, setIsError] = useState(false)
  const [section, setSection] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(_schema)
  const [progressId, setProgressId] = useState()

  const [isShowConnection, setIsShowConnection] = useState(false)
  const [indicatorSelectRow, setIndicatorSelectRow] = useState()
  const [connectionSchema, setConnectionSchema] = useState()

  const dispatch = useDispatch()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    // let progressId = location.search.substring(1)
    let progressId = sessionStorage.getItem('param')?.substring(1)
    // console.log('ProgressIndicatorWidget', _schema, 'progressId', progressId)
    setProgressId(progressId)
    setFormSchema(_schema)
    if (isWithdrawRequest) {
      setProgressId(_schema?.projectProgressId)
    }
  }, [_schema])

  const handleCallService = async (request, projectProgressId) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      // console.log('call update.')
      const response = await updateProgressIndicator(projectId, projectProgressId, request)

      // console.log('response', response)

      if (response) {
        onChangeIsEdit(false)
        setFormSchema(response)
        await dispatch(getSchemaSidebar(projectId))
      } else {
        setIsError(true)
      }
    } catch (e) {
      console.log('error', e)
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleCallCommentService = async (request, projectProgressId) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      if (request.value.value || request.value.id) {
        if (request.value.value) {
          let response

          if (request.value.id) {
            // console.log('call update.')
            response = await updateProgressFeedback(projectId, projectProgressId, request)
          } else {
            // console.log('call save.')
            response = await saveProgressFeedback(projectId, projectProgressId, request)
          }

          // console.log('response', response)
          if (response) {
            onChangeIsEdit(false)
            let _schema = formSchema
            _schema.comment = response
            setFormSchema(_schema)
          } else {
            setIsError(true)
          }
        } else {
          let deleteResult = await deleteProgressFeedback(
            projectId,
            projectProgressId,
            request.value.id
          )

          if (deleteResult == 200) {
            let _schema = await getProgressIndicator(projectId, projectProgressId)
            // console.log('getProgressIndicator', _schema)
            onChangeIsEdit(false)
            setFormSchema(_schema)
          } else {
            setIsError(true)
          }
        }
      }
    } catch (e) {
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleGetConnection = async (rowData) => {
    startLoading()
    setIsLoading(true)
    try {
      var response = await getProgressLinkageIndicators(progressId, rowData.id)
      setConnectionSchema(response)

      setIndicatorSelectRow(rowData)
      setIsShowConnection(true)
    } catch (e) {
      console.log('e', e)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleOnSaveConnection = async (request) => {
    startLoading()
    setIsLoading(true)
    try {
      var response = await saveProgressLinkageIndicators(request, progressId, indicatorSelectRow.id)
      if (response) {
        setIsShowConnection(false)
        setConnectionSchema()
        setIndicatorSelectRow()
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
          duration: 5000,
        })

        const _schema = await getProgressIndicator(projectId, progressId)
        setFormSchema(_schema)
      }
    } catch (e) {
      console.log('e', e)
      notification.open('error', {
        title:
          e?.response?.data?.errors?.message ||
          'ไม่สำเร็จ กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ',
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    // console.log('data', data)

    let valueList = []

    data.datalist.forEach((element) => {
      element.children.forEach((subElement) => {
        subElement.children.forEach((item) => {
          if (item.id.startsWith('ADD_ID_')) {
            item.id = ''
            item.result = null
            item.unit = null
          }

          delete item._parent
          valueList.push(item)
        })
      })
    })
    // ADD_ID_

    //set delete = true
    formSchema.values.forEach((element) => {
      element.children.forEach((subElement) => {
        subElement.children.forEach((master) => {
          //find id in valueList if undefined set delete = true
          let newItem = valueList.find((item) => item.id === master.id)
          if (newItem === undefined) {
            master.isDelete = true
            delete master._parent
            valueList.push(master)
          }
        })
      })
    })

    const request = {
      id: formSchema.id,
      projectVersionId: projectId,
      projectProgressId: progressId,
      values: valueList,
    }
    // console.log('request', request)

    handleCallService(request, progressId)
  }

  const onSubmitComment = (data) => {
    // console.log('onSubmitComment', data)

    const request = {
      id: formSchema.id,
      projectVersionId: projectId,
      projectProgressId: progressId,
      masterSubjectId: formSchema.comment.masterSubjectId,
      value: {
        id: formSchema.comment.id,
        value: data.comment,
      },
    }

    // console.log('request body', request)
    handleCallCommentService(request, progressId)
  }

  const onClearAddNotSave = () => {
    // console.log('onClearAddNotSave')

    var newFormSchema = cloneDeep(formSchema)
    let arr = [...newFormSchema.values]

    if (arr) {
      arr.forEach((element, labelIndex) => {
        element.children.forEach((subElement, childrenIndex) => {
          subElement.children.forEach((item, indicatorIndex) => {
            if (item.id.startsWith('ADD_ID_')) {
              arr[labelIndex].children[childrenIndex].children.splice(indicatorIndex, 1)
            }
          })
        })
      })
      console.log('arr', arr)

      newFormSchema.values = arr

      setFormSchema(newFormSchema)
    }
  }

  const handleOnSelectConnection = (rowData) => {
    // console.log('rowData', rowData)

    handleGetConnection(rowData)
  }

  return (
    <>
      <Panel
        shaded
        header={formSchema.header}
        eventKey={2}
        collapsible
        defaultExpanded
        ref={(section) => {
          setSection(section)
        }}
      >
        {formSchema?.comment?.enableEdit ? (
          <>
            <ProgressIndicatorView schema={formSchema} />

            <hr />

            {isEdit ? (
              <CommentForm
                schema={formSchema.comment}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
              />
            ) : (
              <div>
                <CommentView schema={formSchema.comment} />
              </div>
            )}
          </>
        ) : (
          <>
            <WarningMessage style={{ marginBottom: 10 }} message={formSchema?.comment?.value} />

            {isEdit ? (
              <>
                <ProgressIndicatorForm
                  schema={formSchema}
                  register={register}
                  Controller={Controller}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  clearErrors={clearErrors}
                  projectId={projectId}
                  progressId={progressId}
                  setFormSchema={setFormSchema}
                  onSelectConnection={handleOnSelectConnection}
                />
                {formSchema.isIntellectualProperty && (
                  <>
                    <Message
                      showIcon
                      style={{ marginTop: 10 }}
                      type="warning"
                      description={
                        <div>
                          <span>
                            เนื่องจากมี <b>"งานวิจัย"</b> และ <b>"นวัตกรรม" </b>{' '}
                            กรุณากรอกรายละเอียดงานวิจัยและนวัตกรรม ให้ครบถ้วน
                          </span>
                          <Link
                            to={{
                              pathname: `${pathname.proposal.projectManagement.intellectualProperty}`,
                            }}
                            // onClick={() => {
                            //   sessionStorage.setItem('projectId', projectId)
                            //   sessionStorage.setItem('param', `?${schema.requestId}`)
                            // }}
                          >
                            <u> คลิกเพื่อไปหน้าบันทึกรายละเอียดงานวิจัยและนวัตกรรม</u>
                          </Link>
                        </div>
                      }
                    />
                  </>
                )}
              </>
            ) : (
              <ProgressIndicatorView
                schema={formSchema}
                onSelectConnection={handleOnSelectConnection}
                showConnectionButton={showConnectionButton}
              />
            )}
          </>
        )}

        {showCommandButton && (
          <>
            <hr />
            <ButtonPanel
              isDisabled={isLoading}
              isEdit={isEdit}
              isError={isError}
              buttonText={
                formSchema?.comment?.enableEdit
                  ? formSchema?.comment?.buttonText
                  : formSchema.buttonText
              }
              onSave={handleSubmit(formSchema.comment?.enableEdit ? onSubmitComment : onSubmit)}
              onCancel={() => {
                setIsError(false)
                onChangeIsEdit(!isEdit)
                onClearAddNotSave()
              }}
              onEdit={() => {
                setIsError(false)
                onChangeIsEdit(!isEdit)
                scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
              }}
            />
          </>
        )}
      </Panel>

      {indicatorSelectRow && connectionSchema && (
        <ResultConnectionModal
          schema={connectionSchema}
          isShowConnection={isShowConnection}
          setIsShowConnection={(isShow) => {
            console.log('onHide')
            setIsShowConnection(isShow)
            setConnectionSchema()
            setIndicatorSelectRow()
          }}
          indicatorSelectRow={indicatorSelectRow}
          onSubmitData={(request) => handleOnSaveConnection(request)}
          isProgress={true}
        />
      )}
    </>
  )
}
